import { render, staticRenderFns } from "./tiaozhuan.vue?vue&type=template&id=56d8452a&scoped=true&"
import script from "./tiaozhuan.vue?vue&type=script&lang=js&"
export * from "./tiaozhuan.vue?vue&type=script&lang=js&"
import style0 from "./tiaozhuan.vue?vue&type=style&index=0&id=56d8452a&prod&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d8452a",
  null
  
)

export default component.exports